import { customerSurveyClient } from "@core/clients";
import useCustomLazyQuery from "../../utils/useLazyQuery";
import { SupaCustomerSurveyCompletionsType } from "../../4time/src/shared/types/supabaseFragments";
import { CUSTOMER_SURVEY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

const useGetCustomerAnswersLazy = () => {
  return useCustomLazyQuery<SupaCustomerSurveyCompletionsType | null, string>(
    ["customer-survey/get"],
    async (userPhone) => {
      if (customerSurveyClient) {
        return customerSurveyClient.getCustomerSurveyAnswers(userPhone);
      }

      if (!userPhone) {
        throw new Error("userPhone is required for getCustomerSurveyAnswers fn");
      }

      throw new Error("customerSurveyClient not implemented");
    },
    {
      cacheTime: CUSTOMER_SURVEY_CACHE_EXPIRE_TIME_MS,
      staleTime: CUSTOMER_SURVEY_CACHE_EXPIRE_TIME_MS,
    }
  );
};

export default useGetCustomerAnswersLazy;
